<div class="resizer"></div>
